﻿function serializeFormToObject(form) {
	const patterns = {
		validate: /^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,
		key: /[a-z0-9_]+|(?=\[\])/gi,
		push: /^$/,
		fixed: /^\d+$/,
		named: /^[a-z0-9_]+$/i
	};

	const pushCounters = {};

	function getPushIndex(key) {
		if (pushCounters[key] === undefined) {
			pushCounters[key] = 0;
		}
		return pushCounters[key]++;
	}

	function getValue(name, value) {
		const inputs = form.querySelectorAll(`[name="${name}"]`);
		if (inputs.length > 0 && inputs[0].type === 'checkbox') {
			return value === 'on' ? true : value;
		}
		return value;
	}

	function deepMerge(target, source) {
		for (const key in source) {
			if (!source.hasOwnProperty(key)) continue;

			const targetVal = target[key];
			const sourceVal = source[key];

			if (
				targetVal !== undefined &&
				typeof targetVal !== 'object' &&
				typeof sourceVal !== 'object'
			) {
				// Оба значения — примитивы: объединяем через запятую
				target[key] = targetVal + ',' + sourceVal;
			} else if (
				targetVal !== undefined &&
				typeof targetVal === 'object' &&
				targetVal !== null &&
				typeof sourceVal === 'object' &&
				sourceVal !== null
			) {
				// Оба — объекты/массивы: рекурсивное слияние
				// Сохраняем тип (массив или объект)
				if (Array.isArray(targetVal) && Array.isArray(sourceVal)) {
					// Для массивов — мержим поэлементно
					for (let i = 0; i < sourceVal.length; i++) {
						if (sourceVal[i] === undefined) continue;
						if (targetVal[i] === undefined) {
							targetVal[i] = sourceVal[i];
						} else if (
							typeof targetVal[i] === 'object' &&
							typeof sourceVal[i] === 'object'
						) {
							deepMerge(targetVal[i], sourceVal[i]);
						} else {
							targetVal[i] = targetVal[i] + ',' + sourceVal[i];
						}
					}
				} else {
					deepMerge(targetVal, sourceVal);
				}
			} else {
				// Одно из значений отсутствует — просто записываем
				target[key] = sourceVal;
			}
		}
		return target;
	}

	function buildNestedObject(name, value) {
		const keys = name.match(patterns.key);
		let result = value;

		while (keys.length > 0) {
			const key = keys.pop();

			if (patterns.push.test(key)) {
				const arrayKey = name.replace(/\[\]$/, '');
				const index = getPushIndex(arrayKey);
				const arr = [];
				arr[index] = result;
				result = arr;
			} else if (patterns.fixed.test(key)) {
				const arr = [];
				arr[key] = result;
				result = arr;
			} else if (patterns.named.test(key)) {
				result = { [key]: result };
			}
		}

		return result;
	}

	const formData = new FormData(form);
	let result = {};

	for (const [name, value] of formData.entries()) {
		if (!patterns.validate.test(name)) continue;

		const processedValue = getValue(name, value);
		const nested = buildNestedObject(name, processedValue);

		deepMerge(result, nested);
	}

	return result;
}

module.exports = { serializeFormToObject };